<template>
    <div v-loading="loading">
        <navBox></navBox>
        <div class="banner">
            <img src="https://www-api.multi-metaverse.com:81/uploads/20221222/pic/qGDb2w9vUZhjZ1tdrliYQ6qWHOrghwglFLMvxBya.png" alt="" />
        </div>
        <div class="formLink">
            <div class="wrap">
                <div class="title">Details</div>
                <div class="content">form:<a :href="formLinkList.formlink"  target="_blank" style="color:#428bca;border-bottom:1px solid #428bca;">{{ formLinkList.form }}</a></div>
                <div class="content">datetime：{{ formLinkList.datetime }}</div>
                <div class="content">
                    description:<span v-html="formLinkList.description" class="description"></span>
                </div>
                <div class="title">Filing Formats</div>
                <div
                    class="file"
                    v-for="(cur, i) in formLinkList.files_path"
                    :key="i"
                >
                    <a :href="cur">
                        <img
                            src="@/assets/investor-Relation/pdf.png"
                            alt=""
                            v-if="getFile(cur) == 'pdf'"
                        />
                        <img
                            src="@/assets/investor-Relation/rar.png"
                            alt=""
                            v-if="
                                getFile(cur) == 'rar' || getFile(cur) == 'zip'
                            "
                        />
                        <img
                            src="@/assets/investor-Relation/rtf.png"
                            alt=""
                            v-if="getFile(cur) == 'rtf'"
                        />
                        <img
                            src="@/assets/investor-Relation/word.png"
                            alt=""
                            v-if="getFile(cur) == 'word'"
                        />
                        <img
                            src="@/assets/investor-Relation/xlsx.png"
                            alt=""
                            v-if="getFile(cur) == 'xlsx'"
                        />
                        <img
                                        src="@/assets/investor-Relation/img.png"
                                        alt=""
                                        v-if="
                                            getFile(cur) ==
                                            'jpg'|| getFile(cur) ==
                                            'png'
                                        "
                                    />
                        <span>{{ curFragment(cur) }}</span>
                    </a>
                </div>
            </div>
        </div>
        <!-- <mapBox></mapBox> -->
        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footerBox/footerBox";
import navBox from "@/components/navBox/navBox";
import subNav from "@/components/subNav/subNav";
import mapBox from "@/components/mapBox/mapBox";
export default {
    name: "formLink",
    components: { footerBox, navBox, subNav, mapBox },
    data() {
        return {
            loading: false,
            formLinkList: {},
        };
    },
    created() {
        var id = this.$route.query.id;
        this.$http.getReports().then((res) => {
            this.detailsIds = res.list.map((item) => item.id);
            if (this.detailsIds.includes(id / 1)) {
                this.formLinkList = res.list.find((item) => {
                    return item.id == id;
                });
                console.log(this.formLinkList);
            }
        });
    },
    methods: {
        curFragment(data) {
            let start = data.lastIndexOf("/");
            let end = data.lastIndexOf(".");
            let result = data.substring(start + 1, end);
            return result;
        },
        getFile(url){
            var site=url.lastIndexOf("\.");
            return url.substring(site+1,url.length)
        }
    },
};
</script>
<style lang="less" scoped>
.wrap {
    width: 1200px;
    margin: 0 auto;
}
/*banner*/
.banner img {
    width: 100%;
    // height: 220px;
}
.formLink {
    padding: 0px 0px 20px 0px;
    .title {
        font-size: 25px;
        font-weight: bold;
        color: #428bca;
        padding: 30px 0;
    }
    .content {
        color: #333333;
        font-size: 14px;
    }
    .description{
        font-family: 'Lucida Bright';
    }
    .file {
        margin-bottom: 20px;
        span {
            color: #428bca;
            border-bottom: 1px solid#428bca;
            font-size: 14px;
            margin-left: 10px;
            font-family: 'Lucida Bright';
        }
        img{
            width: 22px;
            height: 25px;   
        }
    }
}
</style>